import { Breakpoint } from '@mui/material/styles'

export const PALETTE = {
  text: '#111827',
  muted: '#6B7280',
  icon: '#9CA3AF',
  border: '#E5E7EB',
  skeleton: '#F3F4F6',
  tile: '#F9FAFB',
  white: '#FFFFFF',
  error: '#DC2626',
  info: {
    text: '#0C4A6E',
    icon: '#0284C7',
    border: '#E0F2FE',
    background: '#F0F9FF',
  },
}

export type GridColumns = Partial<Record<Breakpoint, number>>

export const buildGridSx = (columns: GridColumns, gap: number) => ({
  display: 'grid',
  gap,
  gridTemplateColumns: Object.fromEntries(
    Object.entries(columns).map(([breakpoint, count]) => [breakpoint, `repeat(${count}, minmax(0, 1fr))`])
  ),
})

export const CARD_SX = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  p: 1.5,
  border: `1px solid ${PALETTE.border}`,
  borderRadius: '16px',
  bgcolor: PALETTE.white,
  minWidth: 0,
} as const

export const MUTED_TEXT_SX = {
  fontSize: 11,
  color: PALETTE.muted,
} as const
